import React from 'react';
import './style.css';
import './hero-eagle.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Tokenomics from './components/Tokenomics';
import Ecosystem from './components/Ecosystem';
import About from './components/About';
import HowToBuy from './components/HowToBuy';
import Roadmap from './components/Roadmap';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <Header />
      <main id="main">
        <Hero />
        <Tokenomics />
        <Ecosystem />
        <About />
        <HowToBuy />
        <Roadmap />
      </main>
      <Footer />
    </>
  );
}
